import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/training-collections",
    name: ROUTE_NAME.TRAINING_COLLECTIONS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.TRAINING_COLLECTION_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.TRAINING_COLLECTION_LIST,
        component: () => import("./views/TrainingCollectionList.vue"),
      },
      {
        path: ":id",
        name: ROUTE_NAME.TRAINING_COLLECTION_UPDATE,
        component: () => import("./views/TrainingCollectionUpdate.vue"),
      },
      {
        path: ":id/drills/:drill_id",
        name: ROUTE_NAME.DRILL_UPDATE,
        component: () => import("./views/DrillUpdate.vue"),
      },
    ],
  },
];
